<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-row>
        <a-col :span="8">
          <div class="title-box">
            <p>区域</p>
              <CosSelect style="width: 80%" v-model:value="formState.deptId" placeholder="请选择" :options="regionListRef" :allowClear="false" @change="fetchData" />
          </div>
        </a-col>
        <a-col :span="8">
          <div class="title-box">
            <p>时间</p>
            <a-date-picker
              style="width: 80%"
              v-model:value="formState.date"
              :allowClear="false"
              @change="fetchData"
              picker="month"
            />
          </div>
        </a-col>
      </a-row>
      <!-- <CosViewContent> -->
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="销售线索&商机">
          <Tab1 :formState="formState" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="客户过程管理">
          <Tab2 :formState="formState" />
        </a-tab-pane>
        <a-tab-pane key="3" tab="客户营收管理">
          <Tab3 :formState="formState" />
        </a-tab-pane>
        <a-tab-pane key="4" tab="客户风控管理">
          <Tab4 :formState="formState" />
        </a-tab-pane>
      </a-tabs>
      <!-- </CosViewContent> -->
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Tab1 from './tab1.vue'
import Tab2 from './tab2.vue'
import Tab3 from './tab3.vue'
import Tab4 from './tab4.vue'
import dayjs, { Dayjs } from 'dayjs'
import { shareInfo } from '@dc-platform/dc-interaction'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'

const formState = ref({
  customerRegionEmployeeNoList: [],
  date: dayjs(),
  deptId: undefined,
  startDay: dayjs().startOf('month').format('YYYY/MM/DD'),
  endDay: dayjs().endOf('month').format('YYYY/MM/DD')
})

const regionListRef = ref([])

const fetchRegionList = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/region/list', { deptManagerId: shareInfo.getUserInfo().work_code }).then((res) => {
    const { deptId, regionList } = res.data
    if (!deptId || !regionList) return
    regionList.forEach((item: any) => {
      item.label = item.deptName
      item.value = item.deptId
    })
    regionListRef.value = regionList
    const region = regionList.find((item: any) => item.deptId === deptId) || regionList[0]
    formState.value.deptId = region.deptId
    formState.value.customerRegionEmployeeNoList = region.deptScope || []
    formState.value.region = region
    fetchData()
  })
}

const fetchData = () => {
  const p = { ...formState.value }
  const { deptId, date } = formState.value
  if (!deptId) return
  p.startDay = dayjs(date).startOf('month').format('YYYY/MM/DD')
  p.endDay = dayjs(date).endOf('month').format('YYYY/MM/DD')
  const region = regionListRef.value.find((item: any) => item.deptId === deptId)
  p.customerRegionEmployeeNoList = region?.deptScope || []
  p.region = region
  formState.value = p
}

onMounted(() => {
  fetchRegionList()
})
</script>

<script lang="ts">
export default { name: 'DcCosFbuDataBoardRegion' }
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  background-color: #fff;
  width: 100%;
  height: 50px;
  p {
    color: #666666;
    font-size: 14px;
    font-weight: 500;
    margin-right: 6px;
  }
  .input {
    width: 350px;
    background: #f9f9ff;
    border-radius: 4px;
    border: none;
    margin-left: 18px;
  }
}
</style>
